const encoder = new TextEncoder()
const decoder = new TextDecoder()

/**
 * Accepts bytes and return bytes.
 * @param data
 * @param key
 * @constructor
 */
export function XOR(data: Uint8Array, key: Uint8Array) {
	return data.map((value, i) => value ^ (key[i % key.length] ?? 0))
}

export function utf8ToBytes(string: string) {
	return encoder.encode(string)
}

export function bytesToUtf8(bytes: Uint8Array) {
	return decoder.decode(bytes)
}
